import { FuseSplashScreen } from "@fuse";
import _ from "@lodash";
import {
   AppBar, DialogActions, DialogContent,
   FormControl, FormControlLabel, IconButton, Switch, TextField, Toolbar, Typography, withStyles
} from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import { StringDateUSToBR } from "app/Core/Helpers";
import * as AppActions from "app/store/actions";
import withReducer from "app/store/withReducer";
import copy from "copy-to-clipboard";
import React from "react";
import { MdClose, MdContentCopy } from "react-icons/md";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import Countdown from "../Countdown/Countdown";
import * as Actions from "./Store/Actions/WebexActions";
import reducer from "./Store/Reducers/WebexReducer";

const NewState = {
   idpessoaformulario: null,
   open: false,
   title: "",
   agendado: null,
   aguardandoToken: false,
   timezone: "America/Sao_Paulo",
   start: null,
   end: null,
   sendEmail: true,
};

const styles = () => ({
   root: {},
   switchBase: {
      height: 20,
   },
});

class WebexAgendar extends XAPPComponent {

   state = { ...NewState };

   componentDidMount() {
      const { xappRouteParams, getToken, empresapessoaformulario = null, openAutomatic = false } = this.props;
      let AState = { ...NewState };

      if (!_.isNull(empresapessoaformulario) && !_.isNull(empresapessoaformulario[xappRouteParams.empresa])) {
         AState.idpessoaformulario = empresapessoaformulario[xappRouteParams.empresa].idpessoaformulario;
         getToken(empresapessoaformulario[xappRouteParams.empresa].idpessoaformulario, xappRouteParams);
      }

      if (openAutomatic) {
         AState.open = true;
      }

      this.setState(_.set({ ...AState }));
   }

   componentDidUpdate(prevProps, prevState) {
      const form = this.state;
      const { dados, Reducer, showMessage, clearReducer, agendado = null, save = null, empresapessoaformulario, xappRouteParams } = this.props;
      if (Reducer.error) {
         showMessage({
            message: Reducer.error,
            variant: "error",
         });
         Reducer.error = null;
      }
      if (Reducer.info) {
         this.setState(_.set({ ...this.state }, "agendado", Reducer.agendado));
         if (!_.isNull(save)) {
            save(Reducer.agendado);
         }
         clearReducer();
         Reducer.error = null;
      }

      if (!prevState.open && form.open) {
         let AState = Object.assign({}, NewState);
         AState.idpessoaformulario = empresapessoaformulario[xappRouteParams.empresa].idpessoaformulario;
         AState.open = true;
         AState.agendado = agendado;
         AState.start = dados.inicio;
         AState.end = dados.termino;
         AState.title = !_.isNull(dados.titulo) && dados.titulo.length > 0 ? dados.titulo : "Agendamento " + (!_.isNull(dados.idagendamento) ? dados.idagendamento : "");
         AState.invitees = [];

         dados.clientesLookup.forEach(item => {
            AState.invitees.push({
               "email": item.webex ?? item.email,
               "displayName": item.nome,
               "coHost": false,
            });
         });

         dados.responsaveisLookup.forEach(item => {
            AState.invitees.push({
               "email": item.webex,
               "displayName": item.nome,
               "coHost": true,
            });
         });


         this.setState({ ...AState });
      }

      if (prevState.open && !form.open) {
         this.setState({ ...NewState });
      }
   }

   openDialog = () => {
      this.setState(_.set({ ...this.state }, "open", !this.state.open));
   };

   handleChange = (ev) => {
      this.setState(_.set({ ...this.state }, ev.target.name, ev.target.value));
   };

   handleChangeCheck = (event) => {
      this.setState(_.set({ ...this.state }, event.target.name, event.target.checked));
   };

   canBeSubmitted = () => {
      const form = this.state;
      return !_.isNull(form.title) && typeof form.title === "string" && form.title.length > 0;
   };

   render() {
      const { xappRouteParams, integracao = null, autorizar, agendar, Reducer, deletar, showMessage, classes, getToken } = this.props;
      const form = this.state;

      return (
         <React.Fragment>
            <XAPPButton
               tooltip={{ placement: "top", title: "Agendar videochamada" }}
               type="Icon"
               className="p-8"
               variant="contained"
               color="dafault"
               iconProps=""
               icon={"video"}
               onClick={() => this.openDialog()}
            />
            <XAPPDialog
               id="WebexAgendar"
               open={form.open}
               fullWidth
               maxWidth="sm"
               onClose={() => this.openDialog()}
            >
               <AppBar position="static" elevation={1}>
                  <Toolbar className="flex w-full min-h-0">
                     <Typography variant="subtitle1 text-white">{"Agendar videochamada"}</Typography>
                     <div className="flex-1" />
                     <IconButton key="close" aria-label="Close" className="p-6" onClick={() => this.openDialog()}>
                        <MdClose className="text-20 text-white" />
                     </IconButton>
                  </Toolbar>
               </AppBar>
               <DialogContent classes={{ root: "p-16" }}>
                  {Reducer.preload ?
                     <div className="px-128">
                        <FuseSplashScreen />
                     </div>
                     :
                     <React.Fragment>
                        {(_.isNull(integracao) || _.isUndefined(integracao.access_token)) && !form.aguardandoToken &&
                           <div className="flex w-full flex-col justify-center items-center">
                              <Typography color="textSecondary" variant="h6" className="text-16 mb-8">
                                 {"Inicie sua sessão webex para utilizar esse recurso."}
                              </Typography>
                              <XAPPButton
                                 type="Button"
                                 className=""
                                 variant="contained"
                                 color="primary"
                                 iconProps="mr-8"
                                 icon={"login"}
                                 label={"Iniciar"}
                                 onClick={() => {
                                    this.setState(_.set({ ...this.state }, "aguardandoToken", true));
                                    autorizar(form.idpessoaformulario, xappRouteParams, 0, Reducer.chave);
                                 }}
                              />
                              <Typography color="textSecondary" variant="h6" className="text-16 my-8">
                                 {"Não possui conta? "}
                                 <a
                                    className="text-14 cursor-pointer"
                                    // eslint-disable-next-line react/no-unknown-property
                                    component="button"
                                    onClick={() => autorizar(form.idpessoaformulario, xappRouteParams, 1, Reducer.chave)}
                                 >
                                    Clique aqui
                                 </a>
                              </Typography>

                           </div>
                        }
                        {form.aguardandoToken &&
                           <div className="flex w-full flex-col justify-center items-center">
                              <Typography color="textSecondary" variant="h6" className="text-16 mb-8">
                                 {"Tudo pronto com a sessão webex?"}
                              </Typography>
                              <XAPPButton
                                 type="Button"
                                 className="bg-green hover:bg-green"
                                 variant="contained"
                                 color="primary"
                                 iconProps="mr-8"
                                 icon={"done"}
                                 label={"tudo pronto"}
                                 onClick={() => {
                                    getToken(form.idpessoaformulario, xappRouteParams, () => this.setState(_.set({ ...this.state }, "aguardandoToken", false)));
                                 }}
                              />
                              <Countdown
                                 time={15}
                                 callback={() => {
                                    getToken(form.idpessoaformulario, xappRouteParams, () => this.setState(_.set({ ...this.state }, "aguardandoToken", false)));
                                 }}
                                 texto="Verificando token webex em"
                                 className="mt-12"
                              />
                           </div>
                        }
                        {!_.isNull(integracao) && !_.isUndefined(integracao.access_token) &&
                           <React.Fragment>
                              {!_.isNull(form.agendado) ? (
                                 <React.Fragment>
                                    <div className="flex flex-col px-12">
                                       <Typography color="textSecondary" className="mb-4">
                                          {form.agendado.title}
                                       </Typography>
                                       <Typography color="textSecondary" className="mb-4">
                                          {"Início: " + StringDateUSToBR(form.start)}
                                       </Typography>
                                       <Typography color="textSecondary" className="mb-4">
                                          {"Término: " + StringDateUSToBR(form.end)}
                                       </Typography>
                                       {!_.isUndefined(form.agendado.meetingLink) &&
                                          <Typography
                                             color="textSecondary"
                                             className="mb-4 flex items-center cursor-pointer"
                                             onClick={() => {
                                                copy(form.agendado.meetingLink);
                                                showMessage({
                                                   message: "Link copiado",
                                                   variant: "info",
                                                });
                                             }}
                                          >
                                             {form.agendado.meetingLink.substring(0, 57) + "..."}
                                             <MdContentCopy className="ml-8 text-20" />
                                          </Typography>
                                       }
                                    </div>
                                 </React.Fragment>
                              ) : (
                                 <React.Fragment>
                                    <TextField
                                       className="mb-12"
                                       label={"Titulo"}
                                       id="title"
                                       name="title"
                                       value={form.title}
                                       onChange={this.handleChange}
                                       //variant="outlined"
                                       fullWidth
                                       required
                                       InputLabelProps={{
                                          shrink: true,
                                       }}
                                    />
                                    <Typography color="textSecondary" className="mb-4">
                                       {"Início: " + StringDateUSToBR(form.start)}
                                    </Typography>
                                    <Typography color="textSecondary" className="mb-4">
                                       {"Término: " + StringDateUSToBR(form.end)}
                                    </Typography>
                                    <FormControl className={"mb-4"}>
                                       <FormControlLabel
                                          className={"mx-0"}
                                          labelPlacement={"start"}
                                          control={
                                             <Switch
                                                classes={{ switchBase: classes.switchBase }}
                                                className=""
                                                name={"sendEmail"}
                                                type="checkbox"
                                                checked={form.sendEmail}
                                                onChange={this.handleChangeCheck}
                                             />
                                          }
                                          label={<Typography color="textSecondary">{"Enviar convite por email"}</Typography>}
                                       />
                                    </FormControl>
                                 </React.Fragment>
                              )}
                           </React.Fragment>
                        }
                     </React.Fragment>
                  }
               </DialogContent>
               <AppBar position="static" elevation={3} color="textSecondary">
                  <Toolbar className="flex w-full justify-end min-h-0 px-12">
                     {!_.isNull(integracao) && !_.isUndefined(integracao.access_token) &&
                        <DialogActions>
                           {_.isNull(form.agendado) && (
                              <XAPPButton
                                 type="Button"
                                 className=""
                                 variant="contained"
                                 color="primary"
                                 disabled={!this.canBeSubmitted()}
                                 iconProps="mr-8"
                                 icon={"save"}
                                 label={"Agendar"}
                                 onClick={() => agendar(form, integracao, xappRouteParams, Reducer.chave)}
                              />
                           )}
                           {!_.isNull(form.agendado) && (
                              <XAPPButton
                                 type="Button"
                                 className=""
                                 variant="contained"
                                 color="primary"
                                 iconProps="mr-8"
                                 icon={"delete"}
                                 label={"Excluir"}
                                 onClick={() => deletar(form.agendado, integracao, xappRouteParams)}
                              />
                           )}
                        </DialogActions>
                     }
                  </Toolbar>
               </AppBar>
            </XAPPDialog>
         </React.Fragment>
      );
   }
}

function mapDispatchToProps(dispatch) {
   return bindActionCreators({
      showMessage: AppActions.showMessage,
      agendar: Actions.createMeeting,
      autorizar: Actions.autorizar,
      deletar: Actions.deleteMeeting,
      getToken: Actions.getToken,
      clearReducer: Actions.clearReducer,
   }, dispatch);
}

function mapStateToProps({ Webex, auth }) {
   return {
      Reducer: Webex,
      integracao: Webex.integracao,
      empresapessoaformulario: auth.user.data.settings.empresapessoaformulario,
   };
}

export default withReducer("Webex", reducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(WebexAgendar))));
